module.exports = __webpack_public_path__ + "media/subscription_landing/quote-4565d1dd.svg";